<template>
  <div class="taber">
    <div class="taber_c" @click="tap(index)" v-for="(item,index) in taber" :key="index">
      <div class="taber_c_icon" v-if="now_route_path != item.route_path"><img :src="item.icon" alt="" /></div>
      <div class="taber_c_icon" v-else><img :src="item.sel_icon" alt="" /></div>
      <div class="taber_c_p">{{item.p}}</div>
    </div>
    <!-- <div class="taber_c"  @click="tap(1)">
            <div class="taber_c_icon" v-if="isShow"><img src='../../images/icon/mine.png' alt="" /></div>
            <div class="taber_c_icon" v-else><img src='../../images/icon/mineRed.png' alt="" /></div>
            <div class="taber_c_p">个人中心</div>
        </div>
        <div class="taber_c"  @click="tap(2)">
            <div class="taber_c_icon" v-if="isShow"><img src='../../images/icon/ticket.png' alt="" /></div>
            <div class="taber_c_icon" v-else><img src='../../images/icon/ticketRed.png' alt="" /></div>
            <div class="taber_c_p">我的卡券</div>
        </div> -->
    <!--     <img src="/static/home/mine2_selected.png" /> -->
  </div>
</template>
<script>
  export default {
    data() {
      return {
        taber: [{
            icon: "/static/home/index2.png",
            sel_icon: '/static/home/index2_selected.png',
            p: '服务首页',
            route_path: '/',

          },
          // {
          //     icon: '/static/duihuan.png',
          //     sel_icon:'/static/duihuan1.png',
          //     p: '兑换商品',
          //     route_path:'/duihuan',

          // },
          {
            icon: '/static/home/mine2.png',
            sel_icon: '/static/home/mine2_selected.png',
            p: '个人中心',
            route_path: '/mine',

          }
        ],
        now_route_path: '', //当前路由路径
      }
    },
    created() {
      this.now_route_path = this.$route.path
    },
    mounted() {

    },
    methods: {
      tap(e) {
        switch (e) {
          case 0:
            this.$router.push({
              path: '/'
            })
            break
            // case 1:
            //     this.$router.push({path: '/duihuan'})
            //     break
          case 1:
            this.$router.push({
              path: '/mine'
            })
            break
        }
      }
    }
  }
</script>
<style scoped>
  img {
    width: 100%;
    height: 100%;
  }

  .taber {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    height: 55px;
    background: #fff;
    box-shadow: 0px -4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .taber_c {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .taber_c_icon {
    width: 25px;
    height: 25px;
  }

  .taber_c_p {
    color: #000;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/taber/taber.vue